<script>
// 全局混入
export default {
	computed:{

	},
	created() {
		this.metaMeet()
	},
	watch:{

	},
	methods:{
		metaMeet(){
			if (this.$contentId) {
				//获取创建人信息
				var wxud= localStorage.getItem('wxud') || '',noLoginSid = localStorage.getItem('noLoginSid') || '',userArr= this.$store.state.CreatorInformation.length ? this.$store.state.CreatorInformation : [],createdId= userArr.length ? userArr[0].userId : '';
					
				//登录或者有用户信息，请求接口优先用登录信息
				if(this.$store.state.userInfo.userId || noLoginSid){
					let usid=this.$store.state.userInfo.userId?this.$store.state.userInfo.userId:noLoginSid;
					let data = { id: this.$contentId, userIds:usid+','+createdId,platId:this.getQuery('pfId') ? this.getQuery('pfId') : window.$pfId,userCode: this.$store.state.userInfo.userId ? this.$store.state.userInfo.nickName : wxud,createId:this.getQuery('nowReceiveId')?this.getQuery('nowReceiveId'):''}
					if(this.getQuery('fsfxUrl')){
						data.transmitType = 'business'
					}
					this.$http.get('/meeting-tool-web/interface/meeting/metaMeet', data)
				}
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/mixins/mix-base.vue